import { render } from "./module_introduce.vue?vue&type=template&id=5075e32a"
import script from "./module_introduce.vue?vue&type=script&lang=js"
export * from "./module_introduce.vue?vue&type=script&lang=js"

import "./module_introduce.vue?vue&type=style&index=0&id=5075e32a&scope=true&lang=css"

import exportComponent from "F:\\code\\ywym\\ydd-zht-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__